<template>
  <div class="text-bg">
    <div class="lines">
      <line-animate class="line1"></line-animate>
      <line-animate class="line2"></line-animate>
      <line-animate class="line3"></line-animate>
    </div>
    <div class="arr-bg">
      <div class="paradigm_sketch__pulse paradigm_sketch__pulse1"></div>
      <div class="paradigm_sketch__pulse paradigm_sketch__pulse2"></div>
    </div>
  </div>
</template>

<script>
import lineAnimate from '@/components/home/carousel/line-animate.vue'
export default {
  components: {
    lineAnimate,
  },
}
</script>

<style lang="scss" scoped>
.text-bg {
  position: relative;
  width: 100%;
  display: block;
  height: 400px;
  text-align: center;
  .arr-bg {
    position: relative;
    left: 60px;
  }
  .line1 {
    width: 20px;
    position: absolute;
    left: 50px;
    top: 100px;
    height: 250px;
  }
  .line2 {
    width: 20px;
    position: absolute;
    left: 250px;
    top: 0px;
    height: 250px;
  }
  .line3 {
    width: 20px;
    position: absolute;
    left: 450px;
    top: 150px;
    height: 250px;
  }
  .paradigm_sketch__pulse1 {
    background-image: url('~@/static/images/polygon.svg');
    animation: sketch1 2s infinite;
  }
  .paradigm_sketch__pulse2 {
    background-image: url('~@/static/images/polygon.svg');
    animation: sketch2 2s infinite;
  }
  .paradigm_sketch__pulse {
    width: 384px;
    height: 442px;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/exam/text-bg.vue